import { render, staticRenderFns } from "./RequireChangePassword.vue?vue&type=template&id=3f467d3b&"
import script from "./RequireChangePassword.vue?vue&type=script&lang=js&"
export * from "./RequireChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports